import CompanyStatsSection from "../../components/CompanyStatsSection";
import AwardsRecognition from "../../components/layout/AwardsRecognition";
import CEOSection from "../../components/layout/CEOSection";
import DubaiAreaGuides from "../../components/layout/DubaiAreaGuides";
import FinalCTA from "../../components/layout/FinalCTA";
import LifestyleSection from "../../components/layout/LifestyleSection";
import OurPartners from "../../components/layout/OurPartners";
import OurWorkingAreas from "../../components/layout/OurWorkingAreas";
import PremiumCTASection from "../../components/layout/PremiumCTASection";
import ShortsReelSection from "../../components/layout/ShortsReelSection";
import ShortsReelSectionYT from "../../components/layout/ShortsReelSectionYT";
import TeamGallerySection from "../../components/layout/TeamGallerySection";
import WhyChooseVisionXNexus from "../../components/layout/WhyChooseVisionXNexus";
import PageSEO from "../../components/PageSEO";
import ClientReviewsSlider from "./ClientReviewsSlider";
import ForBuyers from "./ForBuyers";
import ForTenants from "./ForTenants";
import Hero from "./Hero";
import HeroVideo from "./HeroVideo";
import OurAgents from "./OurAgents";
import WhyChooseUs from "./WhyChooseUs";

export default function Home() {
  return (
    <>
      <PageSEO
        title="Vision X Nexus | Luxury Real Estate Consultants in UAE"
        description="cription"
        content="Vision X Nexus is a luxury real estate consultancy in the UAE, offering expert property advisory services across Sharjah, Dubai, and Ajman."
        canonical="https://visionxnexus.com/"
        pageName="Vision X Nexus Home"
        faqs={[
          {
            question: "Do you provide real estate services in Dubai?",
            answer:
              "Yes, Vision X Nexus provides expert real estate advisory services across Dubai, Sharjah, and Ajman.",
          },
          {
            question: "What type of properties do you specialize in?",
            answer:
              "We specialize in residential, commercial, off-plan, and investment properties across the UAE.",
          },
        ]}
      />

      <HeroVideo />
      <CompanyStatsSection />
      <ForBuyers />
      <WhyChooseUs />
      {/* <DubaiAreaGuides/> */}
      {/* <Leadership /> */}
      {/* <CEOSection /> */}
      {/* <ForTenants /> */}
      <ClientReviewsSlider />
      <WhyChooseVisionXNexus />
      <PremiumCTASection />
      <OurPartners />
      {/* <AwardsRecognition /> */}
      <TeamGallerySection />
      <ShortsReelSectionYT />
      <LifestyleSection />
      <OurWorkingAreas />
      <OurAgents />
      <FinalCTA />
    </>
  );
}
